export enum BusinessDateRangeCompareElements {
  LastNext = 0,
  FromTo = 1,
  All = 2
}
